import { LoggedOutHomeImage } from "@faire/deprecated-retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/LoggedOutHomeImage/LoggedOutHomeImage";
import { trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick } from "@faire/web-api--source/events/loggedOutRetailers/click/loggedOutHomeRedesignCta";
import { IBlogCarouselTile } from "@faire/web-api--source/indigofair/data/IBlogCarouselTile";
import { Column } from "@faire/web/slate/Layout";
import { Typography } from "@faire/web/slate/Typography";
import { cn } from "@faire/web/tools/cn";
import { Anchor } from "@faire/web/ui/LinkAnchor";
import React from "react";

import { useIsLoggedOutHomepageV2 } from "../../../useIsLoggedOutHomepageV2";

export const BlogTile: React.FC<{ blogTile: IBlogCarouselTile }> = ({
  blogTile,
}) => {
  const isHomepageRedesignV2 = useIsLoggedOutHomepageV2();
  const { cta_link_url, image, below_image_title } = blogTile;
  if (!image || !cta_link_url || !below_image_title) {
    return null;
  }
  return (
    <Anchor
      href={cta_link_url}
      className="group"
      onClick={() => {
        trackLoggedOutRetailersLoggedOutHomeRedesignCtaClick(
          "blog_carousel-blog-post",
          cta_link_url,
          isHomepageRedesignV2 ? "v2" : "v1"
        );
      }}
    >
      <Column
        gap={12}
        className={cn(
          "h-full w-[260px]",
          isHomepageRedesignV2 ? "md:w-full" : ""
        )}
      >
        <div className="overflow-hidden">
          <LoggedOutHomeImage
            lazyLoad
            responsiveImage={{
              mobileAndAbove: image,
            }}
            optimizeImageOptions={{
              width: 260,
              height: 173,
              resizeMethod: "fill",
            }}
            altText={image.alt_text}
            className={cn(
              "flex h-[173px] w-[260px] lg:origin-left lg:transition-transform lg:duration-[1200ms] lg:ease-[cubic-bezier(0.17,0.67,0.24,1)] lg:group-hover:scale-110",
              isHomepageRedesignV2 ? "md:h-full md:w-full" : ""
            )}
          />
        </div>
        <Typography
          variant="paragraphSansRegular"
          className="group-focus-visible:[outline:2px_solid_var(--core-interactive-focus)_-2px]"
        >
          {below_image_title}
        </Typography>
      </Column>
    </Anchor>
  );
};
